<div class="d-flex skeleton-list-container align-items-center">
    <div class = "front-card">
        <ngx-skeleton-loader
            [animation]="'progress'"
            [count]="1"
            [theme]="{ width: '300px', height: '600px' }"
        ></ngx-skeleton-loader>
    </div>

    <div class="back-card">
        <ngx-skeleton-loader
        [animation]="'progress'"
        [count]="1"
        [theme]="{ width: '300px', height: '600px' }"
        ></ngx-skeleton-loader>
    </div>
    
</div>

<div class="fixed-bottom">
    <ngx-skeleton-loader
        [animation]="'progress'"
        [count]="1"
        [theme]="{ height: '42px' }"
    ></ngx-skeleton-loader>
</div>

